import React from "react"

const ContentBlock = props => {
  return (
    <div
      className={
        "content-block " +
        (props.image.position
          ? "text-image-block image-" + props.image.position
          : "") +
        (props.className ? " " + props.className : "")
      }
      style={
        props.image.url
          ? {
              background: props.overlay,
              backgroundImage: `url(${props.image.url})`,
            }
          : {
              background: props.background && props.background,
            }
      }
    >
      <div style={props.background && { background: props.background }}>
        <div className="container">
          <div className="text-content">
            <h2>{props.title}</h2>
            <p>{props.text}</p>
            {props.cta}
          </div>
          {props.image.url ? (
            <div
              className="image-content"
              style={{ background: props.image.background }}
            >
              <img src={props.image.url} alt={props.image.url} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  )
}

ContentBlock.defaultProps = {
  title: null,
  text: null,
  cta: null,
  background: null,
  image: {},
}

export default ContentBlock
